module.exports = __webpack_public_path__ + "static/media/49_A.0ce0715b.png";